import { Component } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';

import { fadeInOutAnimation } from '../../animations/fade-in-out';
import { ExternalHTMLProvider } from '../../providers/external-html/external-html';

@IonicPage()
@Component({
  selector: 'page-terms-of-use',
  templateUrl: 'terms-of-use.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class TermsOfUsePage {

  content: string;
  err: string;
  loading: boolean;

  showAcceptBtn: boolean = false;
  showBackBtn: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public translate: TranslateService, public externalHTMLProvider: ExternalHTMLProvider) {
    if (this.navParams.get('showBackBtn')) {
      this.showBackBtn = true;
    }
  }

  closeModal() {
    this.navCtrl.pop();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  ionViewDidLoad() {
    if (this.navParams.get('showAcceptBtn')) {
      this.showAcceptBtn = true;
    }

    let locale:string = this.translate.currentLang;
    let filename:string = `assets/i18n/terms-of-use/${locale}.html`;

    this.loading = true;
    this.externalHTMLProvider.get(filename)
      .subscribe(
        content => this.content = content,
        error => {
          this.externalHTMLProvider.get(`assets/i18n/terms-of-use/en.html`)
          .subscribe(
            content => this.content = content,
            error => {
              this.err = <any>error;
              this.loading = false;
            },
            () => {
              this.loading = false;
            }
          );
        },
        () => {
          this.loading = false;
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/pages/terms-of-use/terms-of-use.ts